import { render, staticRenderFns } from "./support.vue?vue&type=template&id=8584cf6e"
import script from "./support.vue?vue&type=script&lang=ts"
export * from "./support.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports